import { render, staticRenderFns } from "./SensorDetailTable.vue?vue&type=template&id=46fcab58&scoped=true&"
import script from "./SensorDetailTable.vue?vue&type=script&lang=js&"
export * from "./SensorDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./SensorDetailTable.vue?vue&type=style&index=0&id=46fcab58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcab58",
  null
  
)

export default component.exports